import qs from "qs";
import React, { useState } from "react";
import KindSelect from "@Components/CarSelect/kindSelect";
import { BottomFillIcon, TopFillIcon } from "@t8891/icon";
import { BookDriveItem, CheckCarItem, CurrentCarItem, InstallmentItem, Insurance } from "./kindTypeList";

const KindTypeSelect: React.FC<any> = ({ kindData, setCar, showKindSelect, toggleSelect }) => {
  let { kindType } = qs.parse(location.search, { ignoreQueryPrefix: true });

  const handleKindSelectChange = (key: "index" | "brand" | "kind", data: any) => {
    if (key === "brand") {
      setCar({ b: data.id });
    }
    if (key === "kind") {
      toggleSelect(false);
      setCar({ k: data.id });
    }
  };
  return (
    <div id='KindTypeDesc' className='relative'>
      <section className='w-full relative mb-24 flex items-center'>
        <div
          className='font-regular pl-10 rounded-4 border-1 border-dashed border-[#bbb] text-[#333] relative justify-center flex text-center items-center text-18 cursor-pointer flex-1 h-40  bg-[#ffffff50]'
          onClick={() => {
            toggleSelect(true);
          }}
        >
          {!kindData?.brandName ? (
            <>請選擇車款</>
          ) : (
            <>
              {kindData?.brandName} {kindData?.kindName}
            </>
          )}
          <div className='absolute right-4'>
            {showKindSelect ? <TopFillIcon size={22} /> : <BottomFillIcon size={22} />}
          </div>
          <KindSelect
            setOpen={toggleSelect}
            open={showKindSelect}
            onChange={handleKindSelectChange}
            className='absolute left-0 top-40 z-30'
          />
        </div>
      </section>

      {kindType === "checkPrice" && <CheckCarItem kindsData={kindData} />}
      {kindType === "installment" && <InstallmentItem kindsData={kindData} />}
      {kindType === "currentCar" && <CurrentCarItem kindsData={kindData} />}
      {kindType === "insurance" && <Insurance kindsData={kindData} />}
      {kindType === "bookDrive" && <BookDriveItem kindsData={kindData} />}
    </div>
  );
};
export default KindTypeSelect;
